import {
  CurrencyUtils,
  useIsMobile,
  useTheme,
} from '@brunommsilva/react-foundations';
import {
  AccountBalanceWallet,
  Balance,
  TrendingDown,
  TrendingUp,
} from '@mui/icons-material';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import KpiCard from '../cards/kpi-card';

interface DashboardSummaryProps {
  income: number;
  expenses: number;
  netResult: number;
  historicalTotalBalance: number;
  isLoading: boolean;
  months: string[];
  amounts: number[];
  revenueValues: number[];
  expenseValues: number[];
  netResultValues: number[];
}

const DashboardSummary = ({
  income,
  expenses,
  netResult,
  historicalTotalBalance,
  isLoading,
  months,
  amounts,
  revenueValues,
  expenseValues,
  netResultValues,
}: DashboardSummaryProps) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isMobile = useIsMobile();

  const formatCurrency = (value: number) => {
    return CurrencyUtils.formatWithCurrency(value, 0);
  };

  return (
    <Grid
      container
      spacing={isMobile ? 1.5 : 3}
      sx={{
        alignItems: 'stretch',
        mb: 3,
      }}
    >
      <Grid
        size={{
          xs: 6,
          sm: 6,
          lg: 3,
        }}
      >
        <KpiCard
          title={t('TOTAL_BALANCE')}
          value={formatCurrency(historicalTotalBalance)}
          Icon={AccountBalanceWallet}
          color={theme.palette.primary.main}
          loading={isLoading}
          labels={months}
          chartData={amounts}
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 6,
          lg: 3,
        }}
      >
        <KpiCard
          title={t('NET_RESULT')}
          value={formatCurrency(netResult)}
          Icon={Balance}
          color={theme.palette.info.main}
          loading={isLoading}
          labels={months}
          chartData={netResultValues}
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 6,
          lg: 3,
        }}
      >
        <KpiCard
          title={t('INCOME')}
          value={formatCurrency(income)}
          Icon={TrendingUp}
          color={theme.palette.success.main}
          loading={isLoading}
          labels={months}
          chartData={revenueValues}
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 6,
          lg: 3,
        }}
      >
        <KpiCard
          title={t('EXPENSES')}
          value={formatCurrency(expenses)}
          Icon={TrendingDown}
          color={theme.palette.error.main}
          loading={isLoading}
          labels={months}
          chartData={expenseValues}
        />
      </Grid>
    </Grid>
  );
};

export default DashboardSummary;
